import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useUser } from 'builder/hooks/useUser'
import { useConfig } from 'builder/hooks/useConfig'
import { ConfigScopesEnum } from 'builder/modules/init'

import { getHost } from '../../../utils'
import SelectResumeImg from '../../../assets/SelectResume.png'

import * as Styles from '../styles'
import { LoadingState, ProcessingState } from '../ResumeProcessing/ResumeProcessing'
export const TRANSLATION = `builder.auto_apply.resume_select`

type Props = {
  isLoading: boolean
  hasDuplicationError?: boolean
  isDulpicationLoading?: boolean
  setShowResumeSelect: (props: boolean) => void
  resumeTitle?: string
}

export const ResumeSelection = ({
  isLoading,
  isDulpicationLoading,
  hasDuplicationError,
  setShowResumeSelect,
}: Props) => {
  const user = useUser()
  const { i18n } = useI18n()
  const config = useConfig(ConfigScopesEnum.country)

  const onSelectResume = () => {
    setShowResumeSelect(true)
    trackInternalEvent('visit_app_resume_selection_popup', {
      label: 'total_job_search_solution',
    })
  }

  if (isLoading || isDulpicationLoading) {
    return (
      <Styles.Box>
        {isLoading && <LoadingState />}
        {isDulpicationLoading && <ProcessingState />}
      </Styles.Box>
    )
  }

  return (
    <Styles.Box $isError={hasDuplicationError} onClick={onSelectResume}>
      <Styles.ImageContainer>
        <Styles.Image $image={SelectResumeImg} />
      </Styles.ImageContainer>
      <Styles.TextContainer>
        <Styles.Header>
          {i18n.t(`${TRANSLATION}.select_from_builder`, {
            host: getHost(user?.scopes.kind, config?.name),
          })}
        </Styles.Header>
        <Styles.Description>
          {i18n.t(`${TRANSLATION}.choose_resume`, {
            host: getHost(user?.scopes.kind, config?.name),
          })}
        </Styles.Description>
      </Styles.TextContainer>
    </Styles.Box>
  )
}
